import { render } from "./QuizCard.vue?vue&type=template&id=2fed4d48&scoped=true"
import script from "./QuizCard.vue?vue&type=script&lang=js"
export * from "./QuizCard.vue?vue&type=script&lang=js"

import "./QuizCard.vue?vue&type=style&index=0&id=2fed4d48&scoped=true&lang=css"

import exportComponent from "/Users/curtismensah/Projects/Litt/Brit/brit-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fed4d48"]])

export default __exports__